import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as TelIcon } from "../../local_icons/tel.svg";
import { useMediaQuery } from "react-responsive";

const Button = ({
  iconPath = undefined,
  hoverIconPath = undefined,
  iconColor = "var(--white)",
  hoverIconColor = undefined,
  iconProps = {},
  text = undefined,
  border = "none",
  hoverBorder = undefined,
  backgroundColor = "transparent",
  hoverBackgroundColor = undefined,
  textColor = "var(--white)",
  hoverTextColor = undefined,
  external_link = undefined,
  internal_link = undefined,
  onClick = undefined,
  isSimple = undefined,
  containerProps = {},
  textAlign = "center",
  blank_text = undefined,
  fontFamily = "UAFSans",
  ...props
}) => {
  const navigate = useNavigate();
  const [isHovering, setIsHovering] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  const goto = () => {
    setIsHovering(false);
    if (onClick) {
      onClick();
      return;
    } else if (internal_link) navigate(internal_link);
  };

  return (
    <div
      style={{ ...containerProps, display: "grid" }}
      onMouseOver={(e) => setIsHovering(true)}
      onMouseOut={(e) => setIsHovering(false)}
    >
      {blank_text && (
        <a
          style={{
            ...styles.buttonContainer,
            border: border,
            backgroundColor: backgroundColor,
            ...props,
            width: "100%",
            overflow: "hidden",
            // clipPath: isHovering ? "inset(0 0% 0 0)" : "inset(0 100% 0 0)",
            opacity: 0,
            justifyContent: textAlign,
            textAlign: textAlign == "start"?"start":"center",
          }}
        >
          {iconPath == "/assets/icons/tel.svg" && (
            <TelIcon style={{ ...iconProps, color: hoverIconColor, transition: "all 0.5s ease" }} />
          )}

          {text && (
            <p
              style={{
                color: backgroundColor,
                overflow: "hidden",
                whiteSpace: "break-spaces",
                maxLines: 1,
                fontFamily: fontFamily,
              }}
            >
              {blank_text}
            </p>
          )}
        </a>
      )}
      <a
        style={{
          ...styles.buttonContainer,
          border: isSimple && isHovering ? hoverBorder : border,
          backgroundColor: isSimple && isHovering ? hoverBackgroundColor : backgroundColor,
          ...props,
          width: "100%",
          // clipPath: isHovering ? "inset(0 0 0 100%)" : "inset(0 0% 0 0)",
          opacity: isSimple ? 1 : isMobile ? 1 : isHovering ? 0 : 1,
          overflow: "hidden",
          textAlign: textAlign == "start"?"start":"center",
          justifyContent: textAlign,
        }}
        href={external_link}
        target={external_link && "_blank"}
        onClick={goto}
      >
        {iconPath == "/assets/icons/tel.svg" && (
          <TelIcon style={{ ...iconProps, color: iconColor, transition: "all 0.5s ease" }} />
        )}

        {text && (
          <p
            style={{
              color: textColor,
              whiteSpace: "break-spaces",
              overflow: "hidden",
              fontFamily: fontFamily,
            }}
          >
            {text}
          </p>
        )}
      </a>
      {!isMobile && (
        <a
          style={{
            ...styles.buttonContainer,
            border: hoverBorder,
            backgroundColor: hoverBackgroundColor,
            ...props,
            width: "100%",
            overflow: "hidden",
            // clipPath: isHovering ? "inset(0 0% 0 0)" : "inset(0 100% 0 0)",
            opacity: isHovering ? 1 : 0,
            justifyContent: textAlign,
          }}
          href={external_link}
          target={external_link && "_blank"}
          onClick={goto}
          onMouseOver={(e) => {}}
          onMouseOut={(e) => {}}
        >
          {iconPath == "/assets/icons/tel.svg" && (
            <TelIcon style={{ ...iconProps, color: hoverIconColor, transition: "all 0.5s ease" }} />
          )}

          {text && (
            <p
              style={{
                color: hoverTextColor,
                overflow: "hidden",
                whiteSpace: "break-spaces",
                fontFamily: fontFamily,
              }}
            >
              {text}
            </p>
          )}
        </a>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  buttonContainer: {
    gridRow: "1",
    gridColumn: "1",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",

    fontFamily: "UAFSans",
    fontSize: "1.25rem",
    fontWeight: 500,
    textAlign: "center",
    textDecoration: "none",
    cursor: "pointer",
    transition: "all 0.5s ease, clip-path 0.5s linear",
    userSelect: "none",
    border: "none",
    padding: "0.75rem 1.5rem",
  },
};

export default Button;
